import { useAuthenticatedUser } from "src/contexts/AuthenticatedUserContext";
import { useAppNavigation } from "src/contexts/AppNavigationContext";
import { FC, useMemo } from "react";
import NavBurgerButton from "../../../components/common/Buttons/NavBurgerButton";
import NavProfileButton from "../../../components/common/Buttons/NavProfileButton";
import ThemeButton from "../../../components/common/Buttons/ThemeButton";
import HelpButton from "../../../components/common/Buttons/HelpButton";
import FeedbackButton from "../../../components/common/Buttons/FeedbackButton";
import LogoHC from "../../../assets/img/logo-top-trim-icon-reposition.png";
import LogoHCDark from "../../../assets/img/logo-h-w-new.png";
import { Link } from "react-router-dom";
import NewNavigationTab from "./NewNavigationTab";
import { AppSettings } from "../../../helpers/AppSettings";
import { useTheme } from "../../../contexts/ThemeContext";
import { primaryNavigationItems } from "../../../routes/routeNavigation";

import "./NewNavigation.scss";

const NewNavigation: FC = () => {
    const { drawerItems } = useAppNavigation();
    const { permissions, user } = useAuthenticatedUser();
    const { light } = useTheme();

    const isAuthed =
        !!user?.roles?.["Global"].includes("BctStaff") ||
        !!user?.roles?.["Global"].includes("Admin");

    const availableNavigationTabs = useMemo(() => primaryNavigationItems(permissions), [permissions]);

    if (!user) return null;

    return (
        <header className="navigation">
            <div className="navigation-container">
                {/**  Navigation menu */}
                <div
                    className="navigation-burger-button"
                    style={{
                        visibility:
                            drawerItems?.length > 0 ? "visible" : "hidden",
                    }}
                >
                    <NavBurgerButton />
                </div>

                {/**  Logo */}
                <img className="header-img" src={light ? LogoHC : LogoHCDark} alt="" />

                {/** Title */}
                <Link className="header-link" to="/" style={{ textDecoration: "none" }}>
                    <h6>Trial Management</h6>
                </Link>

                {/** Right-Side **/}
                <div className="navigation-right-side">
                    {/** Nav Items */}
                    <div className="navigation-tab-container">
                        {isAuthed && availableNavigationTabs.map((tab, index) => (
                            <NewNavigationTab key={`${tab.url}-${index}`} navItem={tab} />
                        ))}
                    </div>
                    {/** Feedback */}
                    {
                        isAuthed && 
                        AppSettings.sentry.dsn && 
                        AppSettings.sentry.enableReportABug && 
                        <FeedbackButton />}

                    {/** Theme */}
                    <ThemeButton />

                    {/** Help */}
                    {isAuthed && <HelpButton />}

                    {/** Profile */}
                    <NavProfileButton />
                </div>
            </div>
        </header>
    );
};

export default NewNavigation;
